import { createStore, applyMiddleware } from 'redux';

import { thunk } from 'redux-thunk';
import logger from 'redux-logger';

import GlobalReducer from './reducers';

export const middlewares = [thunk, logger];

export const store = createStore(GlobalReducer, applyMiddleware(...middlewares));

export default store;
